/**
 * FillExpandCellRenderer
 *
 * Custom cell renderer for the expand column on block rows in the flattened
 * fills grid. Toggles visibility of fill rows by updating the collapsed
 * blocks Set in grid context and triggering external filter re-evaluation.
 *
 * Only renders for block rows that have fills. Returns null for fill rows.
 *
 * Note: This component reads directly from context (no local state) to stay
 * in sync with ExpandCollapseAllHeader when expand/collapse all is triggered.
 */
const FillExpandCellRenderer = (params: any) => {
  if (!params.data || params.data.rowType === "fill") return null;

  const hasFills = params.data.fills && params.data.fills.length > 0;
  if (!hasFills) return null;

  const blockId = params.data.blockId;
  // Read directly from context (no local state) to stay synced with header
  const collapsed =
    params.context?.collapsedFillBlocks?.has(blockId) ?? false;

  const handleToggle = () => {
    if (!params.context?.collapsedFillBlocks) return;

    const newCollapsed = !collapsed;
    if (newCollapsed) {
      params.context.collapsedFillBlocks.add(blockId);
    } else {
      params.context.collapsedFillBlocks.delete(blockId);
    }
    // Trigger filter to show/hide fills, then redraw this row to update icon
    params.api?.onFilterChanged();
    params.api?.redrawRows({ rowNodes: [params.node] });
  };

  return (
    <div
      data-testid="fillExpandCellContainer"
      id="fillExpandCellContainer"
      className="flex h-full w-full cursor-pointer items-center justify-center"
      onClick={handleToggle}
    >
      <span
        className={`ag-icon ${collapsed ? "ag-icon-tree-closed" : "ag-icon-tree-open"}`}
      />
    </div>
  );
};

export default FillExpandCellRenderer;
